// Module
var code = "<tmr-resource-view-header resource=\"$ctrl.resource\" resource-list-title=\"DEVICES.CONVEYORS.VIEW.TITLE\" resource-details=\"$ctrl.details\"></tmr-resource-view-header> <div layout layout-padding> <tmr-device-controls device=\"$ctrl.resource\"></tmr-device-controls> </div> ";
// Exports
var _module_exports =code;;
var path = 'routes/devices/conveyors/conveyor.view.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;